<template>
  <div :class="$style.card">
    <slot name="headerContent">
      <div v-if="showHeader" :class="$style.header">
        <div :class="$style.headerContent">
          <slot name="header">
            <div :class="$style.title">
              {{ title }}
            </div>
            <slot name="action" />
          </slot>
        </div>
      </div>
    </slot>
    <div :class="$style.content">
      <slot />
    </div>
  </div>
</template>
<script>
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component()
export default class LayoutCard extends Vue {
  @Prop({ type: [String, Array] }) title;
  @Prop({ type: Boolean, default: true }) showHeader;
}
</script>
<style module lang="less">
.card {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  overflow: hidden;
  .header {
    height: 0.4rem;
    display: flex;
    align-items: center;
    margin-bottom: 0.08rem;
    background: url('~@/assets/images/smart-hat/screen/title-bg.png') no-repeat;
    background-size: 100% 100%;
    .headerContent {
      flex: 1;
      height: 100%;
      display: flex;
      align-items: center;
      padding: 0 0.1rem 0;
      .title {
        flex: 1;
        font-size: 0.15rem;
        color: rgba(255, 255, 255, 0.9);
        font-weight: 600;
        letter-spacing: 2px;
        // text-shadow: 0 0 7px #1f69c8, 0 0 10px #7db6ff;
        display: flex;
        align-items: center;
        height: 100%;
      }
    }
    .headerContent::before {
      content: '';
      height: 0.27rem;
      width: 0.32rem;
      background: url('~@/assets/images/smart-hat/screen/title-l-icon.png')
        no-repeat;
      background-size: 100% 100%;
    }
    .headerContent::after {
      content: '';
      height: 0.13rem;
      width: 0.13rem;
      margin-left: 0.1rem;
      background: url('~@/assets/images/smart-hat/screen/title-r-icon.png')
        no-repeat;
      background-size: 100% 100%;
    }
  }
  .content {
    // display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
  }
}
:global {
  .hat-screen-card-select {
    width: 0.9rem;
    height: 0.28rem;
    font-size: 0.14rem;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 3px;
    color: #fff;
    .ant-select-selection--single {
      border-radius: 0;
      height: 0.32rem;
    }
    .ant-select-selection__rendered {
      color: #ffffff;
    }
    .ant-select-search__field__placeholder,
    .ant-select-selection__placeholder {
      color: #ffffff;
    }
    .ant-select-focused,
    .ant-select-selection,
    .ant-select-selection:focus,
    .ant-select-selection:active {
      border-color: transparent;
      box-shadow: none;
    }
    .anticon-down {
      color: #fff;
    }
    & + * {
      margin-left: 0.05rem;
    }
  }
  .hat-screen-card-select-dropdown {
    background: #364a5b;
    .ant-select-dropdown-menu {
      padding: 0;
    }
    .ant-select-dropdown-menu-item {
      color: #fff;
      font-size: 0.14rem;
    }
    .ant-select-dropdown-menu-item:hover {
      background: #286fad;
    }
    .ant-select-dropdown-menu-item-selected {
      background: #286fad;
    }
    .x-empty-content--label {
      color: #9ac0d9;
      font-size: 0.12rem;
    }
    .ant-select-dropdown-menu-item-selected {
      background: #286fad;
      color: #fff;
    }
  }
}
</style>
